



















































































import Vue from 'vue';
// import buyer, { Buyer } from '@/modules/buyer/buyer';
// import company, { Company } from '@/modules/buyer/company';
// // import * as calender from '@/modules/calender';
// import { calender } from 'mostra';
import {
  buyer,
  BuyerListItem,
  calender,
} from 'mostra';

export type DataType = {
  buyerList: BuyerListItem[];
  currentPage: number;
  perPage: number;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-admin-buyer-index',
  data(): DataType {
    return {
      buyerList: [],
      currentPage: 1,
      perPage: 500,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        this.buyerList = await buyer.loadBuyerList(this.perPage, 1, val);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      this.buyerList = await buyer.loadBuyerList(this.perPage, 1);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
  methods: {
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.buyerList = await buyer.loadBuyerList(this.perPage, targetPage, this.isForced);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickCountAllBuyers() {
      this.total = await buyer.countAllBuyers();
    },
  },
  //   async onClickSearch(id: string) {
  //     this.$loading(true);
  //     try {
  //       this.selectedBrandId = id;
  //       this.brandInfo = await favorite.getBrandFavoriteCount(id);
  //       this.items = await favorite.getItemsFavoriteCount(id);
  //     } catch (error: any) {
  //       this.$error('検索に失敗しました。', error);
  //     } finally {
  //       this.$loading(false);
  //     }
  //   },
  // },
});
